import Tr from 'translations/Translations';

export const OfferChoiceState = {
    NEW: "NEW",
    READY: "READY",
    PENDING: "PENDING",
    ACCEPTED: "ACCEPTED",
    REJECTED: "REJECTED"
}
const _TR_PREFIX = 'offer_choice_state_';

export const OfferChoiceStateLabel = (status) => (Tr(_TR_PREFIX + status.toLowerCase()));
const _DECISION_STATES = [OfferChoiceState.ACCEPTED, OfferChoiceState.PENDING, OfferChoiceState.READY];
export const isOfferChoiceStateWithDecision = (status) => (_DECISION_STATES.indexOf(status) > -1);
